/*
*/
import React, {useState} from "react";
import { useHistory } from 'react-router-dom';
import Info from '../../components/modal/Info';
import EnviarFotoForm from './EnviarFotoForm';
import {findDriversAction} from '../../actions/EnviarFotoActions';

import {
  Row,
  Col,
  Container
} from 'reactstrap';

import {obterDados} from '../../utils/Session';

let info = React.createRef();

const problemasComSeusDados = () => (
  <div>
    <div>* Revise seus dados e tente novamente</div>
    <div>* Se o problema persistir entre em contato com o TAXI.RIO Cidades</div>
  </div>
);

const naoHabilitado = () => (
  <div>
    <div>* Entre em contato com sua Prefeitura e solicite a sua inclusão no serviço.</div>
    <div>* Dúvidas? Entre em contato com o TAXI.RIO Cidades</div>
  </div>
);

const EnviarFoto = () => {

  const handleSubmit = (values, dispatch) => {
    
    if(JSON.stringify(values) === '{}') return ;

    values.cityId = obterDados().cityId;
    dispatch(findDriversAction(values));

  }

  const [mensagem] = useState({titulo:'', opcao:0});
  let history = useHistory();
  let session = obterDados();
  if(!session) {
    history.push("/");
  }
  return (
    <>
      <Info ref={info} titulo={mensagem.titulo} >
        {
          (mensagem.opcao===1 && problemasComSeusDados()) ||
          (mensagem.opcao===2 && naoHabilitado())
        }
      </Info>

      <Container fluid className="home-container">
        <Row>
          <Col xs={12} md={12} lg={12}>
            <EnviarFotoForm cityId={obterDados().cityId} onSubmit={(values, dispatch) => handleSubmit(values, dispatch)}/>
          </Col>
        </Row>
      </Container>

    </>
  )};

export default EnviarFoto;
